import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const results = ['Más energía', 'Mejor estado físico', 'Mayor disciplina', 'Mejor autoestima', 'Hábitos saludables', 'Más confianza'];
export function Results() {
  return <section className="py-8 md:py-16 px-4 bg-zinc-900/50" data-id="element-199">
      <div className="max-w-4xl mx-auto text-center" data-id="element-200">
        <h2 className="text-xl md:text-4xl font-bebas text-white mb-5 md:mb-10 leading-tight" data-id="element-201">
          RESULTADOS EN MENOS DE 90 DÍAS
        </h2>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4" data-id="element-202">
          {results.map((res, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.85
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07
        }} whileHover={{
          scale: 1.05,
          borderColor: 'rgb(34 197 94)'
        }} className="bg-zinc-900 border border-zinc-700 px-3 py-1.5 md:px-6 md:py-3 rounded-full flex items-center gap-1.5 md:gap-3" data-id="element-203">
              <CheckCircle className="w-3.5 h-3.5 md:w-5 md:h-5 text-green-500" data-id="element-204" />
              <span className="text-white font-medium text-xs md:text-base" data-id="element-205">
                {res}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}